import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { showModal } from 'actions/common'
import { gridSetCurrentEditingSellableItem } from 'actions/grid'
import { GRID_TICKET_MODAL } from 'constants/modal-constants'
import { getSellableItems } from 'selectors/grid'

import GridSidebar from './grid-sidebar'

class GridSidebarContainer extends Component {

  constructor(props) {
    super(props)

    this.onAddTicket = this.onAddTicket.bind(this)
  }

  onAddTicket() {
    this.props.gridSetCurrentEditingSellableItem(null)
    this.props.showModal(GRID_TICKET_MODAL)
  }

  render() {
    return (
      <GridSidebar {...this.props} onAddTicket={this.onAddTicket} />
    )
  }
}

GridSidebarContainer.propTypes = {
  gridSetCurrentEditingSellableItem: PropTypes.func.isRequired,
  sellableItems: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  sellableItems: getSellableItems(state),
})

const mapDispatchToProps = {
  gridSetCurrentEditingSellableItem,
  showModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(GridSidebarContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-sidebar/grid-sidebar-container.js
 **/